import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import TestErrors from "../../features/errors/TestError";
import { ToastContainer } from "react-toastify";
import ServerError from "../../features/errors/ServerError";
import LoginForm from "../../features/users/LoginForm";
import { useStore } from "../stores/store";
import LoadingComponent from "./LoadingComponent";
import ModalContainer from "../common/modals/ModalContainer";
import SGPersonaForm from "../../features/SGPersonas/form/SGPersonaForm";
import ScrollToTop from "../../components/Scroll";
import "../../App.css";
// import Navbar from "../../components/Menus/Navbar";
//import Inicio from "../../components/pages/Inicio";
import SignUp from "../../components/pages/SignUp";
//import loginM from "../../components/pages/loginM";

import NuestroPortafolio from "../../components/pages/NuestroPortafolio";
import Certificaciones from "../../components/pages/Certificaciones";
import Asesorias from "../../components/pages/Asesorias";
import Curso from "../../components/pages/Curso";
import asesoria from "../../components/pages/Asesoria";
import Cursos from "../../components/pages/Cursos";
import Certificacion from "../../components/pages/Certificacion";
import Posgrados from "../../components/pages/Posgrados";
import Posgrado from "../../components/pages/Posgrado";

import ProfilePage from "../../features/profiles/ProfilePage";
//import Noticias from "../../components/pages/Noti";
import Configuracion from "../../components/pages/config";
import PrivateRoute from "./PrivateRoute";
import CargaPagos from "../../components/Pagos/Operaciones";
import NodeDetail from "../../components/pages/Alfresco/nodeDetail";
import Autenticarse from "../../components/Menus/ValMoodle";
import Pass from "../../components/pages/PassReload";
import PagarT from "../../features/profiles/PagarT";
import loginConfirmacion from "../../components/loginConfirmacion";
import ListaDocentes from "../../components/Reportes/ListaDocentes";

import PortafolioHome from "../../components/Portafolio/PortafolioHome";
import ResultadosBusqueda from "../../components/Portafolio/ResultadosBusqueda";
import PreguntasFrecuentes from "../../components/pages/preguntas_frecuentes";

import PortafolioHomePeten from "../../components/Portafolio/PortafolioHomePeten";

import NavbarHeader from "../../components/Menus/NavbarNewMenu"

import CursosPeten from "../../components/pages/CursosPeten";
import AsesoriasPeten from "../../components/pages/AsesoriasPeten";
import PosgradosPeten from "../../components/pages/PosgradosPeten";
import CertificacionesPeten from "../../components/pages/CertificacionesPeten";

import FinancieroListaConvenios from "../../components/Convenios/FinancieroListaConvenios";
import DetalleConveniosFinanciero from "../../components/Convenios/FinancieroDetalleConvenios";
import DetalleConvenios from "../../components/Convenios/DetalleConvenios";
import CreateConvenios from "../../components/Convenios/CreateConvenios";
// import ImpresionConvenio from "../../components/Convenios/ImpresionConvenio";
import DocenteCursos from "../../components/Reportes/DocenteCursos";
import ReporteInscritosEd from '../../components/Reportes/ReporteInscritosEd';
//import ReportesInstitucionlaes from '../../components/PerfilInstitucional/ReportesInstitucionales'

import PefilInstitucional from "../../components/PerfilInstitucional/PerfilInstitucional"
import EntradaAdministrador from "../../components/Convenios/EntradaConvenios";
import CreateSolicitudes from "../../components/Convenios/CreateSolicitudes"
import ListaSolicitudes from '../../components/Convenios/ListaSolicitudes';
import ConveniosXinstitucion from "../../components/PerfilInstitucional/ConveniosXinstitucion";
import SolicitudesXinstitucion from "../../components/PerfilInstitucional/SolicitudesXinstitucion";
import EstudiantesXConvenio from "../../components/PerfilInstitucional/EstudiantesXConvenio"
import LoggedInUser from "../../components/pages/homelogged";
import OperacionesHome from "../../components/Operaciones/OperacionesHome";
import DetalleConvenioInstitucional from "../../components/PerfilInstitucional/DetalleConvenioInstitucional";

function App() {
  const location = useLocation();
  const { commonStore, userStore } = useStore();
  const {
    userStore: { logout, isLoggedIn },
  } = useStore();
  //let rut: any;

  useEffect(() => {
    if (commonStore.token) {
      userStore.getUser().finally(() => commonStore.setAppLoaded());
    } else {
      commonStore.setAppLoaded();
    }
  }, [commonStore, userStore]);

  if (!commonStore.appLoaded)
    return <LoadingComponent content="Cargando la aplicación..." />;
  return (
    <>
      <ToastContainer position="bottom-right" hideProgressBar />

      <ModalContainer />
      <NavbarHeader />
      {/* <Navbar /> */}
      <ScrollToTop />

      <Route exact path="/portafolios" component={NuestroPortafolio} />
      <Switch>
        <Route exact path="/" component={PortafolioHome} />
        <Route exact path="/peten/" component={PortafolioHomePeten} />

        <Route path="/cursos" component={Cursos} />
        <Route path="/asesorias" component={Asesorias} />
        <Route path="/posgrados" component={Posgrados} />
        <Route path="/certificaciones" component={Certificaciones} />

        <Route path="/peten/cursos" component={CursosPeten} />
        <Route path="/peten/asesorias" component={AsesoriasPeten} />
        <Route path="/peten/posgrados" component={PosgradosPeten} />
        <Route path="/peten/certificaciones" component={CertificacionesPeten} />

        <Route path="/curso/:id?/:idUser?" component={Curso} />
        <Route path="/asesoria/:id?/:idUser?" component={asesoria} />
        <Route path="/certificacion/:id?/:idUser" component={Certificacion} />
        <Route path="/posgrado/:id?/:idUser" component={Posgrado} />
        <Route path="/aulavirtual" component={Certificaciones} />
        <Route path="/sign-up" component={SignUp} />
        <Route path="/reiniciopass" component={Pass} />
        <Route path="/login-confirmacion" component={loginConfirmacion} />
        <Route path="/resultados_busqueda" component={ResultadosBusqueda} />

        <Route path="/preguntas_frecuentes" component={PreguntasFrecuentes} />

        <PrivateRoute path="/reportes-docentes/:id?" component={ListaDocentes} />
        <PrivateRoute path="/reporte/edicion/:id?" component={ReporteInscritosEd} />
        <PrivateRoute path="/docente/:id?" component={DocenteCursos} />

        <PrivateRoute path="/solicitudes/crear-solicitud" component={CreateSolicitudes} />
        <PrivateRoute path="/solicitudes/lista" component={ListaSolicitudes} />
        <PrivateRoute path="/financiero/convenios" component={FinancieroListaConvenios} />
        <PrivateRoute path="/financieros/convenios/detalle/:id?" component={DetalleConveniosFinanciero} />
        <PrivateRoute path="/convenios-panel" component={EntradaAdministrador} />

        <PrivateRoute path="/perfil-institucional" component={PefilInstitucional} />
        <PrivateRoute path="/reportes/convenios-institucionales" component={ConveniosXinstitucion} />
        <PrivateRoute path="/institucion/convenios/detalle/:id?" component={DetalleConvenioInstitucional} />
        <PrivateRoute path="/reportes/solicitudes-institucionales" component={SolicitudesXinstitucion} />
        <PrivateRoute path="/reportes/estudiantes-convenio" component={EstudiantesXConvenio} />
        <PrivateRoute path="/home/profile" component={LoggedInUser} />

        {/*<PrivateRoute path="/home/profile/:username/:id?" component={ProfilePage} />*/}
        <PrivateRoute path="/SGPersonas/:id?" component={SGPersonaForm} />
        <PrivateRoute path="/configuracion/:id?" component={Configuracion} />
        <PrivateRoute path="/expediente/:id?" component={NodeDetail} />
        <PrivateRoute path="/valmoodle" component={Autenticarse} />
        <PrivateRoute path="/perfilpago" component={PagarT} />

        <PrivateRoute path={"/home/operaciones"} component={OperacionesHome} />

        {/* <PrivateRoute path="/financieros/convenios/:id" component={DetalleConveniosFinanciero} /> */}
        <PrivateRoute path="/convenios/:id" component={DetalleConvenios} />
        <PrivateRoute path="/cargapagos/crear-convenio" component={CreateConvenios} />

        <PrivateRoute path="/cargapagos/:id" component={CargaPagos} />

        <Route path="/errors" component={TestErrors} />
        <Route path="/server-error" component={ServerError} />
        <Route exact path="/inicio" component={PortafolioHome} />

        <Route path="/login" component={LoginForm} />
      </Switch>
      {/* <Router>
        <Route
          path={"/(.+)"}
          render={() => (
            <>
               <Container style={{marginTop: '0em', display: 'hide'}}>
              </Container>
            </>
          )}
        />
      </Router> */}
    </>
  );
}
export default observer(App);
